export const hotelStatuses = {
  Unknown: 'Unknown',
  ReadyToOnboard: 'ReadyToOnboard',
  PendingPhoneNumberSetup: 'PendingPhoneNumberSetup',
  PendingCampaignBrandRegistration: 'PendingCampaignBrandRegistration',
  PendingCampaignGeneration: 'PendingCampaignGeneration',
  PendingCampaignProviderImport: 'PendingCampaignProviderImport',
  PendingCampaignProviderNumberAssociation: 'PendingCampaignProviderNumberAssociation',
  ReadyToStart: 'ReadyToStart',
  Started: 'Started',
  BasicAccount: 'BasicAccount',
  SmallAccount: 'SmallAccount',
  MediumAccount: 'MediumAccount',
  LargeAccount: 'LargeAccount',
  KeyAccount: 'KeyAccount',
  AboutToLose: 'AboutToLose',
  Churned: 'Churned'
}

export const hotelStatusesCanRegisterCampaign = [
  'PendingCampaignBrandRegistration'
  // 'PendingCampaignGeneration',
  // 'PendingCampaignProviderImport',
  // 'PendingCampaignProviderNumberAssociation'
]
export const hotelStatusesRegistedCampaign = [
  'ReadyToStart',
  'Started',
  'BasicAccount',
  'SmallAccount',
  'MediumAccount',
  'LargeAccount',
  'KeyAccount',
  'AboutToLose',
  'Churned'
]

export const hotelStatusesEditable = [
  'Started',
  'BasicAccount',
  'SmallAccount',
  'MediumAccount',
  'LargeAccount',
  'KeyAccount',
  'AboutToLose',
  'Churned',
  'Paused'
]

export const hotelStatusNames = {
  Unknown: 'Unknown',
  ReadyToOnboard: 'Ready to onboard',
  PendingPhoneNumberSetup: 'Pending telecom setup',
  PendingCampaignBrandRegistration: 'Pending campaign registration',
  PendingCampaignGeneration: 'Pending campaign generation',
  PendingCampaignProviderImport: 'Pending campaign provider import',
  PendingCampaignProviderNumberAssociation:
    'Pending campaign provider number association',
  ReadyToStart: 'Ready to start',
  Started: 'Started',
  BasicAccount: 'Basic account',
  SmallAccount: 'Small account',
  MediumAccount: 'Medium account',
  LargeAccount: 'Large account',
  KeyAccount: 'Key account',
  AboutToLose: 'About to lose',
  Churned: 'Churned',
  Paused: 'Paused'
}

export const hotelSubsidiaryPmsHealthyKinds = {
  PartiallyWorking: 'PMS partially working',
  PasswordWrong: 'PMS password wrong',
  PasswordExpired: 'PMS password expired',
  NotIntegrated: 'PMS is not integrated',
  SyncStopped: 'PMS sync stopped'
}

export const hotelCampaignRegistrationStatuses = [
  'PendingCampaignBrandRegistration',
  'PendingCampaignGeneration'
]

export const hotelCampaignProviderImportStatuses = [
  'PendingCampaignProviderImport',
  'PendingCampaignProviderNumberAssociation'
]

export const hotelStatusNamesFilterable = {
  PendingCampaignBrandRegistration: 'Pending campaign reg.',
  PendingPhoneNumberSetup: 'Pending telecom setup',
  PendingCampaignProviderImport: 'Pending campaign import',
  BasicAccount: 'Basic account',
  MediumAccount: 'Medium account',
  LargeAccount: 'Large account',
  AboutToLose: 'About to lose',
  Paused: 'Paused',
  Churned: 'Churned'
}

const colors = {
  great: '#eab308',
  good: '#509c13',
  ok: '#66bb6a',
  badish: '#ed8d3d',
  bad: '#F96262',
  ready: 'var(--linkBlue)',
  neutral: 'rgba(0, 0, 0, 0.25)'
}

export const hotelStatusColors = {
  Unknown: colors.neutral,
  ReadyToOnboard: colors.neutral,
  PendingPhoneNumberSetup: colors.bad,
  PendingCampaignBrandRegistration: colors.bad,
  PendingCampaignGeneration: colors.bad,
  PendingCampaignProviderImport: colors.bad,
  PendingCampaignProviderNumberAssociation: colors.bad,
  ReadyToStart: colors.ok,
  Started: colors.good,
  BasicAccount: colors.good,
  SmallAccount: colors.good,
  MediumAccount: colors.great,
  LargeAccount: colors.great,
  KeyAccount: colors.great,
  AboutToLose: colors.bad,
  Churned: colors.neutral
}
